<template>
  <div class="about" :class="!_isMobile ? 'mt88' : 'warpMt'">
    <img :class="_isMobile ? 'bannerStyleM' : 'bannerStylePc'"   :src="_isMobile ? 'https://cdn.youjiajk.com/aboutBannerMobile1.png' : 'https://cdn.youjiajk.com/aboutBannerPc_YS_new.png'" />
    <aboutPc v-if="!_isMobile" :newsList="newsList" :teamList="teamList" :aboutTxt="aboutTxt"></aboutPc>
    <aboutMobile v-else :newsList="newsList" :teamList="teamList":aboutTxt="aboutTxt"></aboutMobile>
    <!-- <customizedService v-if="!_isMobile" text="联系我们"></customizedService> -->
  </div>
</template>

<script>
import aboutPc from './pc/aboutPc.vue'
import aboutMobile from './mobile/aboutMobile.vue'
import customizedService from '../components/customizedServicePc.vue'
import axios from 'axios'
  export default {
     metaInfo(){
      return {
        meta:[
          {
            name: 'title',
            content: '优加健保健康科技 ( 北京 ) 有限公司'
          },
          {
            name:'keywords',
            content:'优加健康,优加健保健康科技 ( 北京 ) 有限公司,医疗保险,创新医疗险,技术团队'
          },
          {
            name: 'description',
            content: '优加健康 一支既懂医疗又懂保险的专业化团队 针对创新医疗险的产品/服务创新和落地能力,服务覆盖百万人群。 针对商保的医疗式专家型管理服务团队,行业权威协会和专业院校共同培训及认证。 精通健康险及互联网数据运营的产品及技术团队。'
          }
        ]
      }
    },
    data() {
      return {
        _isMobile: false,
        teamList: [{
          title: '有实力',
          desc:'我们来自平安、泰康、百度、爱康国宾、阿里健康、好大夫、京东健康等金融、互联网、医疗圈的顶流公司'
        },{
          title: '看未来',
          desc: '来自北大、清华、人大等学府，我们拥有永往直前的冲劲、奔放驰骋的想法、坚定的执行力、自由的言论空间'
        },{
          title: '显个性',
          desc: '我们支持所有人释放自己——在这里，每一个人都是点点星火，而星火可以燎原'
        }],
         newsList:[{
           href: 'https://mp.weixin.qq.com/s/LySpOFUW8oU0rlEn1aYiNQ',
           imgUrl: 'https://cdn.youjiajk.com/64011111.png',
           title: '优加健康荣登中国创新医疗服务榜100强',
           desc: '2022年第六届未来医疗100强大会云峰会于6月14日正式启幕，大会期间，备受业界瞩目的未来医疗100强榜单重磅公布。'
         },
         {
           href: 'https://mp.weixin.qq.com/s/aiO3Zm-VG1sfjObte4QzmQ',
           imgUrl: 'https://cdn.youjiajk.com/%E5%A4%B4%E5%9B%BE.png',
           title: '优加健康<线上门诊险>荣获今日保·《2022年度互联网保险产品》奖',
           desc: '近日，今日保·保险中介榜单揭晓。优加健康凭借线上门诊险 “互联网+医疗”的方式提供的全闭环互联网门诊保险服务，在医疗健康服务领域成绩突出，荣获“2022年度互联网保险产品”奖。'
         },
         {
           href: 'https://mp.weixin.qq.com/s/HfPyoY9THXsUie_7lbjErg',
           imgUrl: 'https://cdn.youjiajk.com/640.jpeg',
           title: '优加健保（青岛）互联网医院圆满通过验收审核，即将迎来上线运营',
           desc: '5月20日，优加健康旗下优加健保（青岛）互联网医院平台在青岛顺利圆满通过主管机构和专家团的评审验收，将于近期正式上线运营。'
         },
         {
           href: 'https://mp.weixin.qq.com/s/-fuS1VdeOZOOHSPajmaJww',
           imgUrl: 'https://cdn.youjiajk.com/11111111.png',
           title: '医疗管理专家李丽主任加盟优加健康，助力管理式医疗服务平台全面升级',
           desc: '行业领先的商保数字化管理式医疗服务平台优加健康近日宣布，知名医疗管理及中西医结合专家李丽教授，正式加盟担任优加健康首席医疗官一职。'
         },
         {
           href: 'https://mp.weixin.qq.com/s/8WCiBBPQzj9fsS1xI1ljsw',
           imgUrl: 'https://cdn.youjiajk.com/yjjk_news_01.png',
           title: '优加健康完成数千万人民币B轮融资，持续打造数字化商保管理式医疗服务平台',
           desc: '近日，优加健保健康科技（北京）有限公司（以下简称“优加健康”）宣布完成B轮数千万人民币的首笔融资。'
         },
         {
           href: 'https://mp.weixin.qq.com/s/Rc6XyK--0IP_CJ8Wl7t4GQ',
           imgUrl: 'https://cdn.youjiajk.com/2%E3%80%81%E4%BC%98%E6%A2%A6%E6%83%B3%20%E5%8A%A0%E9%80%9F%E5%BA%A6%20%E8%B7%91%E8%B5%A22022.png',
           title: '优梦想 加速度 跑赢2022 ',
           desc: '2021年是快速成长的一年。优加营收同比增加3倍,服务能力不断加强,客户口碑持续传播,市场认可逐渐提高,目前已完成B轮数千万融资。'
         },
         {
           href: ' https://mp.weixin.qq.com/s/Q5VZsNmfReNhFv08tMi5jw',
           imgUrl: 'https://cdn.youjiajk.com/%E4%BC%98%E5%8A%A0%E5%81%A5%E5%BA%B7%E4%B8%8E%E2%80%9C%E5%B9%B3%E5%AE%89%E5%A5%BD%E7%94%9F%E6%B4%BB%E2%80%9DAPP.png',
           title: '优加健康与“平安好生活”APP联合推出优选药品商城，打造医药健服务闭环',
           desc: '近日优加健康宣布和平安财险板块平安好生活APP合作的优选药品商城正式上线。'
         },
         {
           href: 'https://mp.weixin.qq.com/s/WQqYqhgZEKPM9DPOKptjCA',
           imgUrl: 'https://cdn.youjiajk.com/4%E3%80%8111%E6%9C%88%E6%9C%8D%E5%8A%A1%E9%80%9F%E9%80%92_.png',
           title: '11月服务速递| 意外住院关爱宝等众多产品服务连连看',
           desc: '优加健康新出“意外住院关爱宝”，融合意外险、家财险效果翻倍'
         },
         {
           href: 'https://mp.weixin.qq.com/s/se_kTA29AePZ8kgsav5p8w',
           imgUrl: 'https://cdn.youjiajk.com/%E4%BC%98%E5%8A%A0%E5%81%A5%E5%BA%B7%E5%85%A8%E6%96%B0%E7%BA%BF%E4%B8%8A%EF%BC%86%E7%BA%BF%E4%B8%8B%E9%97%A8%E8%AF%8A%E9%99%A9%E6%9C%8D%E5%8A%A1%EF%BC%8C.png',
           title: '优加健康全新线上＆线下门诊险服务，全方位升级用户体验',
           desc: '如今提起互联网诊疗大家一定不陌生，有很多场景都会让人可以接触到它，比如家里小孩不舒服，发烧、拉肚子，在互联网医院，在线就能咨询医生孩子的病情如何，该怎么处理，可以吃哪些药，要不要去医院就诊等等。'
         },
         {
          href:'https://mp.weixin.qq.com/s/nnPrpKBIZmrUqCEacmfbag',
          imgUrl:'https://cdn.youjiajk.com/companydynamic_n1.png',
          title:'10月服务月报|线上＆线下门诊险上',
          desc:'在如今的健康险市场中，线上门诊险在一定程度上填补市场需求的产品空白'
        },{
          href:'https://mp.weixin.qq.com/s/OP1TqlHmREnp7_Z3UYZY_A',
          imgUrl: 'https://cdn.youjiajk.com/companydynamic_n2.png',
          title:'数字化健康服务驱动未来增长|2021分子乌镇保险科技节，优加健康荣获“2021中国保险科技100强”',
          desc:'2021分子乌镇保险科技节，优加健康荣获“2021中国保险科技100强”'
        },{
          href:'https://mp.weixin.qq.com/s/fznKWHJ32VDsFDMrNukYIw',
          imgUrl:'https://cdn.youjiajk.com/companydynamic_n3.png',
          title:'9月新闻快报|视频医生火热上市',
          desc:'为满足用户就医需求，提升用户服务体验，优加健康全新推出视频医生服务'
        },{
          href:'https://mp.weixin.qq.com/s/cn5uo4-djTYsHNG49aVLRA',
          imgUrl: 'https://cdn.youjiajk.com/640.png',
          title: '优加健康联合清华清湛人工智能研究院共同推进健康险创新',
          desc:'专注于服务商保的管理式医疗服务组织优加健康近日宣布，与依托于清华大学人工智能研究院的南京清湛人工智能研究院达成战略合作并成立合资公司（优湛科技），共同设立联合创新实验室'
        },{
          href:'https://mp.weixin.qq.com/s/VyEnWj6iBPXuk0b6Ncbgrw',
          imgUrl: 'https://cdn.youjiajk.com/companyHonor1.png',
          title: '重磅|数字化健康管理与保险深度融合，不忘生命守护初心',
          desc:'近日，被视为中国健康产业最具影响力、具有强大前瞻性的第十四届中国健康产业（国际）生态大会（以下简称“西普会”）在博鳌盛大举行'
        },{
          href: 'https://mp.weixin.qq.com/s/jSkJTzSzHx5mW-XBEHOUrA',
          imgUrl: 'https://cdn.youjiajk.com/companyHonor2.png',
          title: '8月服务快报|“女王卡”“慢U惠”火爆上市',
          desc: '为满足用户就医需求，提升用户服务体验，优加健康全新推出视频医生服务'
        },{
          href: 'https://mp.weixin.qq.com/s/hxDjKVGJhAuloR5VetTIFg',
          imgUrl: 'https://cdn.youjiajk.com/companyHonor3.png',
          title: '新职场，新起航|优加健康喜迁新居',
          desc: '随着客户对优加健康的信赖与支持，我们得以不断成长、团队也日益壮大，为更好、更高效的服务客户、提升伙伴的工作体验以及客户和合作伙伴的来访感受，优加健康宣布，我们迁新居啦'
        },{
          href: 'https://mp.weixin.qq.com/s/HLDi5V7F1H3Hhriv3HZH8w',
          imgUrl: 'https://cdn.youjiajk.com/companyHonor4.png',
          title: '7月服务快报|齿科服务、慢病管理服务等服务速递',
          desc: '根据 2017 年 9 月卫计委发布的第四次全国口腔健康流行病学调查结果，我国儿童口腔疾病患病率成上升趋势'
        },{
          href: 'https://mp.weixin.qq.com/s/5T1kxAClaMQYN4wCVUh_kg',
          imgUrl: 'https://cdn.youjiajk.com/%E5%9B%9B%E5%91%A8%E5%B9%B4.png',
          title: '四载韶华不负梦，乘风破浪会当行—优加健康四周年庆',
          desc: '不忘初心，做商业医疗健康险服务领域积极推动者'
        },{
          href: 'https://mp.weixin.qq.com/s/d7iGWDxmelqoxHAaNsHMMQ',
          imgUrl: 'https://cdn.youjiajk.com/%E5%A4%B4%E5%9B%BE6.png',
          title: '优加健康6月新闻快报',
          desc: ''
        },{
          href: 'https://mp.weixin.qq.com/s/S0bfXOhuHoxgYoyzHnI3eQ',
          imgUrl: 'https://cdn.youjiajk.com/%E5%A4%B4%E5%9B%BE1.jpg',
          title: '优加健康联合泰康在线、微保首推“微医保·互联网医疗险”升级保障—互联网医院药品费用保险金，探索“百万医疗险”持续发展与深度运营',
          desc: '优加健康将持续联合生态伙伴，赋能健康险高速成长'
        },{
          href: 'https://mp.weixin.qq.com/s/6r37rtb3D0hjGd-75QmMOg',
          imgUrl: 'https://cdn.youjiajk.com/%E5%B3%B0%E4%BC%9A%E5%A5%96%E6%9D%AF%E5%9B%BE.jpg',
          title: '优加健康荣获“2021最佳健康险智能服务平台提供商”，进一步呈现医疗健康智能供应链赋能价值',
          desc: ''
        },{
          href: 'https://mp.weixin.qq.com/s/ErcObqGNJlAnJxcrbWpGp',
          imgUrl: 'https://cdn.youjiajk.com/%E5%A4%B4%E5%9B%BE3.png',
          title: '优加健康5月新闻快报',
          desc: ''
        },{
          href: 'https://mp.weixin.qq.com/s/c1e7WIx4QhYT5X8Ak3EP2Q',
          imgUrl: 'https://cdn.youjiajk.com/news6.png',
          title: '优加健康4月新闻快报',
          desc: '赋能商保，给用户"需要”的，而不是"被营销"的健康保障方案'
        },{
          href: 'https://mp.weixin.qq.com/s/Gewoa4nlsMxtDvgJqBHfyQ',
          imgUrl: 'https://cdn.youjiajk.com/news5.png',
          title: '健康服务+保险深度融合大趋势 | 优加健康董事长丁浩川在第五届未来医疗100强大会发表演讲--全面赋能商保创新',
          desc: '全面赋能商保创新'
        },{
          href: 'https://mp.weixin.qq.com/s/d7iGWDxmelqoxHAaNsHMMQ',
          imgUrl: 'https://cdn.youjiajk.com/news4.png',
          title: '优加健康荣获人保健康2020年度优秀健康管理服务合作伙伴--优加健康基于线上线下“全、广、专”的协同性优选医疗健康网络的服务价值进一步获得了市场的认可。',
          desc: '优加健康基于线上线下“全、广、专”的协同性优选医疗健康网络的服务价值进一步获得了市场的认可。'
        },{
          href: 'https://mp.weixin.qq.com/s/gMpkfzO6F6tbLv6S6HzzHA',
          imgUrl: 'https://cdn.youjiajk.com/news1.png',
          title: '我心柔软，却有力量！—致女性创业者--优加健康创始人＆CEO王艳萍女士荣获2021年30位最值得关注的创业女神',
          desc: '优加健康创始人＆CEO王艳萍女士荣获2021年30位最值得关注的创业女神'
        },{
          href: 'https://mp.weixin.qq.com/s/qmXdTRoYtjVsk0KTG22Arw',
          imgUrl: 'https://cdn.youjiajk.com/news2.png',
          title: '过去实“鼠”不易 优加守护前行--2021“牛”转乾坤',
          desc: '2021“牛”转乾坤'
        },{
          href: 'https://mp.weixin.qq.com/s/tZjyBdx37WM9X7tq4Zo_KA',
          imgUrl: 'https://cdn.youjiajk.com/news3.png',
          title: '躬身前行 悉心服务—优加健康2020客户服务年报- 我们一直关注您的健',
          desc: '我们一直关注您的健康'
        }],
        aboutTxt: ''
      }
    },
    components: {
      aboutPc,
      aboutMobile,
      customizedService
    },
    created() {
      this._isMobile = this.$util._isMobile()
      this.getAboutTxt()
    },
    methods: {
      getAboutTxt() {
        let url = ''
        let _currentUrl = window.location.href
        // 判断是不是测试环境的域名
        if (_currentUrl.indexOf('youjiajk.com') > -1) {
          url = "https://ums.youjiajk.com/website/moduleText/find?moduleName=关于我们"
        } else {
          url = "https://ums.youjiajktest.com/website/moduleText/find?moduleName=关于我们"
        }
        axios.get(url, {}).then(res => {
          if(res.data.code == 0) {
            this.aboutTxt = res.data.data.moduleText
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
.about {
  display: flex;
  flex-direction: column;
  .bannerStyleM{
    width: 100%;
    object-fit: cover;
  }
  .bannerStylePc{
    width: 100%;
    object-fit: cover;
  }
}
 .mt88 {
    margin-top: 88px;
  }
  .warpMt{
    margin-top: 1.55rem;
  }
</style>


// WEBPACK FOOTER //
// src/views/about.vue